export default __webpack_public_path__ + "static/a_type_pdf-349421920206cdb981501eb8a14258ec.pdf";